export const NOTIFICATIONS_REFRESH_EVENT = 'notifications:refresh';

export const refreshNotifications = () => {
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_REFRESH_EVENT));
};
